import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { UserModule } from './user/user.module';
//import { UploaderModule } from './uploader/uploader.module';

import {dealers_portal_menu, menu} from './menu';
import { routes } from './routes';
import {AuthService} from '../services/auth.service';

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes,{
          enableTracing: false,
          useHash: true
        }),
        UserModule,
        //UploaderModule
    ],
    declarations: [],
    exports: [
        RouterModule
    ]
})
export class RoutesModule {
    constructor(private menuService: MenuService) {
      menuService.addMenu(menu);
    }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/routes.module.ts